export default __webpack_public_path__ + "static/media/YU_Neg_Branco.1f0d0fc0.png";